import { TextFieldProps, Typography, Theme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useGetLocationForSelectLazyQuery } from '../../generated/graphql';
import { makeStyles } from '@mui/styles';

interface SelectLocationProps {
  locationId: number | undefined;
}

interface SelectLocationInterface {
  id: number;
  name: string;
  address: string;
}

export const buttonStyle = makeStyles((theme: Theme) => ({
  button: {
    borderColor: `${theme.palette.error.main} !important`,
    color: `${theme.palette.error.main} !important`,
    cursor: 'pointer',
  },
  editButton: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    cursor: 'pointer',
  },
  promoteButton: {
    borderColor: `${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
    cursor: 'pointer',
    marginRight: theme.spacing(1),
  },
  demoteButton: {
    borderColor: `${theme.palette.warning.main} !important`,
    color: `${theme.palette.warning.main} !important`,
    cursor: 'pointer',
    marginRight: theme.spacing(1),
  },
}));

export function ViewLocation(props: SelectLocationProps & TextFieldProps) {
  const { locationId } = props;
  const [value, setValue] = useState<SelectLocationInterface | null>(null);
  const [getLocation, { data: locationData }] =
    useGetLocationForSelectLazyQuery();
  useEffect(() => {
    if (locationId != null) {
      getLocation({ variables: { locationId: locationId } });
    }
  }, [locationId]);

  useEffect(() => {
    if (locationData) {
      setValue(locationData.location);
    }
  }, [locationData]);

  return (
    <Typography
      style={{
        fontSize: 14,
      }}
    >{` ${value?.name}`}</Typography>
  );
}
